var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',_vm._l((_vm.header),function(item,i){return _c('th',{key:i,class:[
        `text-${_vm.getAlignment(item.align)}`,
        {"cursor-pointer": item.sortable}
      ],on:{"click":() => {
        if (item.sortable) {
          _vm.$emit("clickHeaderItem", item)
        }
      }}},[(item.value === "selected" && _vm.$getRight("categoryCreate") && _vm.$getRight("itemEdit"))?_c('div',[_c('v-simple-checkbox',{attrs:{"color":"#9e9bd2"},model:{value:(_vm.selectAllComputed),callback:function ($$v) {_vm.selectAllComputed=$$v},expression:"selectAllComputed"}})],1):_c('div',{staticClass:"inventory_headerItem text-no-wrap"},[_c('span',{style:({
            color: _vm.computedSortColor(item)
          })},[_vm._v(_vm._s(item.text))]),(item.sortable)?_c('v-icon',{staticClass:"inventory_headerItem_icon",style:({
            "opacity": item.sortState.active ? 1 : 0.5
          }),attrs:{"size":"16","color":_vm.computedSortColor(item)}},[_vm._v(" "+_vm._s(_vm.computedSortIcon(item))+" ")]):_vm._e()],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }